export const formatMessageText = (text: string) => {
    const patterns: [RegExp, string][] = [
        [/\*\*(.*?)\*\*/g, '<strong>$1</strong>'],    // Bold using **
        [/__(.*?)__/g, '<strong>$1</strong>'],        // Bold using __
        [/\*(.*?)\*/g, '<em>$1</em>'],                // Italic using *
        [/_([^_]+)_/g, '<em>$1</em>'],                // Italic using _
        [/~~(.*?)~~/g, '<del>$1</del>'],              // Strikethrough using ~~
        [/`(.*?)`/g, '<code>$1</code>'],              // Inline code using `
        [/### (.*?)$/gm, '<h3>$1</h3>'],              // Heading 3
        [/## (.*?)$/gm, '<h2>$1</h2>'],               // Heading 2
        [/# (.*?)$/gm, '<h1>$1</h1>'],                // Heading 1
        [/^\s*[-*+]\s+(.*)/gm, '<li>$1</li>'],        // Unordered list items
        [/^\s*\d+\.\s+(.*)/gm, '<li>$1</li>'],        // Ordered list items
    ];

    let formattedText = text.replace(/\n/g, "<br>"); // Replace newlines with <br> tags
    // formattedText = formattedText.replace(/- (.*?\.\w+(\.\w+)?)/g, "<dt>$1</dt>");

    // Apply regex patterns
    patterns.forEach(([pattern, replacement]) => {
        formattedText = formattedText.replace(pattern, replacement);
    });


    // Replace tabs with &nbsp; (or you can use CSS for better control)
    formattedText = formattedText.replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;"); // Four spaces for each tab

    // Additional custom formatting for file extensions (assuming dt format for files)
    // formattedText = formattedText.replace(/- (.*?\.\w+)(?!\.\w+)/g, "<dt>$1</dt>");
    // formattedText = formattedText.replace(/(<dt>.*?<\/dt>)\s*<br\s*\/?>/g, '$1');
    // formattedText = formattedText.replace(/(<dt>.*?<\/dt>)(?!.*<dt>)/, '$1<br>');

    return formattedText;
};